import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const SingleStore = ({ height = 24, width = 24, ...props }: SvgIconProps) => (
  <SvgIcon
    data-test="SingleStore"
    height={height}
    width={width}
    title="SingleStore logo"
    titleId="template-logo-title"
    viewBox="0 0 256 256"
    {...props}
  >
    <defs>
      <linearGradient
        x1="67.3449258%"
        y1="-26.0044686%"
        x2="-18.5227789%"
        y2="22.9877555%"
        id="singleStoreLinearGradient-1"
      >
        <stop stopColor="#FF7BFF" offset="0%"></stop>
        <stop stopColor="#AA00FF" offset="35.0158%"></stop>
        <stop stopColor="#8800CC" offset="100%"></stop>
      </linearGradient>
      <linearGradient
        x1="36.2591509%"
        y1="-19.3628763%"
        x2="111.72205%"
        y2="44.9975357%"
        id="singleStoreLinearGradient-2"
      >
        <stop stopColor="#FF7BFF" offset="3.54358%"></stop>
        <stop stopColor="#8800CC" offset="57.6537%"></stop>
        <stop stopColor="#311B92" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g>
      <path
        d="M133.793438,0 C161.220114,7.62806846 186.208847,26.8506986 196.569923,50.3452712 C212.416431,88.4856134 208.759637,136.695058 191.389506,165.376569 C176.761849,188.8709 154.211058,201.381085 128.308006,201.075829 C88.0823106,200.770814 55.4752171,168.732936 55.1704441,128.456768 C55.1704441,88.1803574 86.8634599,54.9221798 128.308006,54.9221798 C135.012288,54.9221798 144.679052,55.851955 155.649674,60.4286222 C155.649674,60.4286222 147.762766,55.757287 127.50695,52.6192355 C69.3015772,44.9912153 0.621898574,89.095884 16.4683968,190.701711 C38.409617,229.757339 80.4639504,256.303989 128.308006,255.997284 C198.703093,255.692994 256.299161,198.024717 255.996071,127.236226 C255.996071,59.498847 200.836263,1.83073691 133.793438,0 Z"
        fill="url(#singleStoreLinearGradient-1)"
      />
      <path
        d="M181.635561,54.0037552 C171.884031,33.5605356 151.771183,17.3889203 127.087223,10.9813448 C121.601791,9.45574074 115.811828,8.84547014 109.412318,8.540359 C99.9653199,8.540359 90.8230945,9.76087603 81.376096,12.2018618 C57.9109865,19.2196838 41.455174,32.950265 31.7034025,43.6293966 C19.20906,57.9701518 10.9810571,72.9211776 6.1052197,87.8722034 C6.1052197,88.1774594 5.8004708,88.4824739 5.8004708,89.0927445 C5.4957219,90.3132857 4.27677462,93.9746678 4.27677462,94.8901944 C3.97202572,95.500465 3.97202572,96.4157502 3.66730098,97.0260207 C3.36255208,98.2465619 3.05780318,99.4668616 2.75307844,100.687403 C2.75307844,100.992659 2.75307844,101.297673 2.44832954,101.602688 C-5.47492441,140.963571 7.68750379,176.286091 15.6107577,189.406305 C17.5925312,192.688049 19.2199033,195.425935 20.8508738,197.938019 C2.87119611,100.298588 54.558966,53.6984992 113.373885,52.477958 C144.152582,51.8679289 174.931278,64.3778723 189.863709,89.3980006 C188.949389,75.6672745 188.035312,68.0392543 181.635561,54.0037552 Z"
        fill="url(#singleStoreLinearGradient-2)"
      />
    </g>
  </SvgIcon>
);
